import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Helper } from 'src/app/shared/Helper';

interface Estado {
  estadoId: string;
  codigoEstado: string;
  nome: string;
  ativo: boolean;
}

interface Cidade {
  cidadeId: string;
  codigoCidade: string;
  nome: string;
  estadoFk: string;
  ativo: boolean;
  jaAssociada?: boolean;
}

interface CidadeRegiao {
  cidadeRegiaoId?: string;
  regiaoFk?: string;
  cidadeFk?: string;
  cidade?: Cidade;
  nome: string;
  ativo: boolean;
}

interface Regiao {
  regiaoId?: string;
  nome: string;
  estado: string;
  estadoFk?: string;
  descricao: string;
  ativo: boolean;
  cidades: CidadeRegiao[];
}

interface ItemSelecao {
  id: string;
  descricao: string;
  detalhe: string;
  bloqueado?: boolean;
}

interface ConfirmacaoLoteModal {
  aberto: boolean;
  carregando: boolean;
  cidades: ItemSelecao[];
}

@Component({
  selector: 'app-cad-regiao',
  templateUrl: './cad-regiao.component.html',
  styleUrls: ['./cad-regiao.component.css']
})
export class CadRegiaoComponent implements OnInit {
  public filtro = '';
  public regioes: Regiao[] = [];
  public estados: Estado[] = [];
  public itemCorrente: Regiao = null;
  public exibirFormulario = false;
  public salvando = false;
  public mensagem = '';

  public modalAberto = false;
  public modalTitulo = '';
  public modalSubtitulo = '';
  public modalFiltro = '';
  public modalCarregando = false;
  public modalVazioMensagem = 'Nenhum item disponível para seleção.';
  public modalItens: ItemSelecao[] = [];
  public modalSelecionadoId = '';
  public modalFiltroAplicado = '';

  public confirmacaoLote: ConfirmacaoLoteModal = {
    aberto: false,
    carregando: false,
    cidades: []
  };

  private modalAcao: 'incluirCidade' | 'transferirCidade' | '' = '';
  private modalCidadeRegiaoId = '';

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit() {
    this.carregarEstados();
    this.carregarRegioes();
  }

  public goToHome() {
    Helper.NavToDashboard(this.router, 'Leads');
  }

  public carregarEstados() {
    this.http.get<Estado[]>(Helper.baseApiUrl + 'regiao/estados').subscribe((res) => {
      this.estados = res || [];
    }, () => {
      this.mensagem = 'Erro ao carregar estados.';
    });
  }

  public carregarRegioes() {
    const filtroTexto = (this.filtro || '').trim();
    let url = Helper.baseApiUrl + 'regiao';
    if (filtroTexto) {
      url += '?filtro=' + encodeURIComponent(filtroTexto);
    }

    this.http.get<Regiao[]>(url).subscribe((res) => {
      this.regioes = res || [];
      if (this.itemCorrente && this.itemCorrente.regiaoId) {
        const atualizado = this.regioes.find(r => r.regiaoId === this.itemCorrente.regiaoId);
        if (atualizado) {
          this.editar(atualizado);
        }
      }
    }, () => {
      this.mensagem = 'Erro ao carregar regiões.';
    });
  }

  public adicionarRegiao() {
    this.exibirFormulario = true;
    this.mensagem = '';
    this.itemCorrente = {
      nome: '',
      estado: '',
      estadoFk: '',
      descricao: '',
      ativo: true,
      cidades: []
    };
  }

  public editar(item: Regiao) {
    this.exibirFormulario = true;
    this.mensagem = '';

    this.itemCorrente = {
      regiaoId: item.regiaoId,
      nome: item.nome,
      estado: item.estado || '',
      estadoFk: item.estadoFk,
      descricao: item.descricao,
      ativo: item.ativo,
      cidades: (item.cidades || []).map(c => ({
        cidadeRegiaoId: c.cidadeRegiaoId,
        regiaoFk: c.regiaoFk,
        cidadeFk: c.cidadeFk,
        cidade: c.cidade,
        nome: c.nome,
        ativo: c.ativo
      }))
    };
  }

  public cancelar() {
    this.exibirFormulario = false;
    this.itemCorrente = null;
    this.mensagem = '';
  }

  public salvar() {
    if (!this.itemCorrente) {
      return;
    }

    if (!(this.itemCorrente.nome || '').trim()) {
      this.mensagem = 'Nome da região é obrigatório.';
      return;
    }

    if (!(this.itemCorrente.estadoFk || '').trim()) {
      this.mensagem = 'Estado é obrigatório.';
      return;
    }

    this.salvando = true;
    this.mensagem = '';

    const estadoSelecionado = this.estados.find(e => e.estadoId === this.itemCorrente.estadoFk);

    const payload = {
      regiaoId: this.itemCorrente.regiaoId,
      nome: (this.itemCorrente.nome || '').trim(),
      estado: estadoSelecionado ? estadoSelecionado.nome : (this.itemCorrente.estado || '').trim(),
      estadoFk: this.itemCorrente.estadoFk,
      descricao: (this.itemCorrente.descricao || '').trim(),
      ativo: this.itemCorrente.ativo,
      cidades: this.itemCorrente.cidades
    };

    if (this.itemCorrente.regiaoId) {
      this.http.put(Helper.baseApiUrl + 'regiao/' + this.itemCorrente.regiaoId, payload).subscribe(() => {
        this.salvando = false;
        this.cancelar();
        this.carregarRegioes();
      }, (err) => {
        this.salvando = false;
        this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao salvar região.';
      });
    } else {
      this.http.post(Helper.baseApiUrl + 'regiao', payload).subscribe(() => {
        this.salvando = false;
        this.cancelar();
        this.carregarRegioes();
      }, (err) => {
        this.salvando = false;
        this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao salvar região.';
      });
    }
  }

  public excluir(item: Regiao) {
    if (!item || !item.regiaoId) {
      return;
    }

    if ((item.cidades || []).length > 0) {
      this.mensagem = 'Não é permitido excluir região com cidades associadas.';
      return;
    }

    if (!confirm('Deseja realmente excluir a região "' + item.nome + '"?')) {
      return;
    }

    this.http.delete(Helper.baseApiUrl + 'regiao/' + item.regiaoId).subscribe(() => {
      this.mensagem = '';
      this.carregarRegioes();
    }, (err) => {
      this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao excluir região.';
    });
  }

  public abrirModalIncluirCidade() {
    if (!this.itemCorrente || !this.itemCorrente.regiaoId) {
      this.mensagem = 'Salve a região antes de incluir cidades.';
      return;
    }

    if (!this.itemCorrente.estadoFk) {
      this.mensagem = 'Selecione o estado da região antes de incluir cidades.';
      return;
    }

    this.abrirModalSelecao('incluirCidade', 'Incluir cidade', 'Selecione uma cidade para associar à região.', 'Nenhuma cidade disponível para seleção.');
    this.carregarItensModal();
  }

  public excluirCidade(cidade: CidadeRegiao) {
    if (!cidade || !cidade.cidadeRegiaoId) {
      return;
    }

    this.http.delete(Helper.baseApiUrl + 'regiao/cidades/' + cidade.cidadeRegiaoId).subscribe(() => {
      this.mensagem = '';
      this.carregarRegioes();
    }, (err) => {
      this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao remover cidade da região.';
    });
  }

  public abrirModalTransferirCidade(cidade: CidadeRegiao) {
    if (!cidade || !cidade.cidadeRegiaoId) {
      return;
    }

    this.modalCidadeRegiaoId = cidade.cidadeRegiaoId;
    this.abrirModalSelecao('transferirCidade', 'Transferir cidade', 'Selecione a região de destino (mesmo estado).', 'Nenhuma região de destino disponível para transferência.');
    this.carregarItensModal();
  }

  public fecharModal() {
    this.modalAberto = false;
    this.modalTitulo = '';
    this.modalSubtitulo = '';
    this.modalFiltro = '';
    this.modalCarregando = false;
    this.modalItens = [];
    this.modalSelecionadoId = '';
    this.modalFiltroAplicado = '';
    this.modalAcao = '';
    this.modalCidadeRegiaoId = '';
  }

  public onModalFiltroChange() {
    this.carregarItensModal();
  }

  public emModoIncluirCidade() {
    return this.modalAcao === 'incluirCidade';
  }

  public listarTodasCidadesEstado() {
    if (this.modalAcao !== 'incluirCidade') {
      return;
    }

    this.modalFiltro = '';
    this.carregarItensModal();
  }

  public abrirConfirmacaoIncluirLote() {
    if (this.modalAcao !== 'incluirCidade') {
      return;
    }

    const cidadesDisponiveis = (this.modalItens || []).filter(item => !item.bloqueado);

    if (cidadesDisponiveis.length === 0) {
      this.mensagem = 'Não há cidades disponíveis para inclusão neste filtro.';
      return;
    }

    this.confirmacaoLote = {
      aberto: true,
      carregando: false,
      cidades: cidadesDisponiveis
    };
  }

  public fecharConfirmacaoLote() {
    this.confirmacaoLote.aberto = false;
    this.confirmacaoLote.carregando = false;
    this.confirmacaoLote.cidades = [];
  }

  public confirmarIncluirLote() {
    if (!this.itemCorrente || !this.itemCorrente.regiaoId) {
      this.fecharConfirmacaoLote();
      return;
    }

    const cidadeFks = (this.confirmacaoLote.cidades || []).map(c => c.id);
    if (cidadeFks.length === 0) {
      this.fecharConfirmacaoLote();
      return;
    }

    this.confirmacaoLote.carregando = true;

    this.http.post(Helper.baseApiUrl + 'regiao/' + this.itemCorrente.regiaoId + '/cidades/lote', {
      cidadeFks: cidadeFks
    }).subscribe(() => {
      this.fecharConfirmacaoLote();
      this.fecharModal();
      this.mensagem = '';
      this.carregarRegioes();
    }, (err) => {
      this.confirmacaoLote.carregando = false;
      this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao incluir cidades em lote.';
    });
  }

  public selecionarItemModal(item: ItemSelecao) {
    if (item.bloqueado) {
      return;
    }

    this.modalSelecionadoId = item.id;
  }

  public confirmarModal() {
    if (!this.modalSelecionadoId) {
      this.mensagem = 'Selecione um item para continuar.';
      return;
    }

    const acaoAtual = this.modalAcao;
    const itemSelecionado = this.modalSelecionadoId;
    const cidadeRegiaoAtual = this.modalCidadeRegiaoId;

    this.fecharModal();

    if (acaoAtual === 'incluirCidade') {
      this.http.post(Helper.baseApiUrl + 'regiao/' + this.itemCorrente.regiaoId + '/cidades', {
        cidadeFk: itemSelecionado,
        ativo: true
      }).subscribe(() => {
        this.mensagem = '';
        this.carregarRegioes();
      }, (err) => {
        this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao incluir cidade na região.';
      });
      return;
    }

    if (acaoAtual === 'transferirCidade') {
      this.http.put(Helper.baseApiUrl + 'regiao/cidades/transferir', {
        cidadeRegiaoId: cidadeRegiaoAtual,
        regiaoDestinoFk: itemSelecionado
      }).subscribe(() => {
        this.mensagem = '';
        this.carregarRegioes();
      }, (err) => {
        this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao transferir cidade.';
      });
    }
  }

  private abrirModalSelecao(acao: 'incluirCidade' | 'transferirCidade', titulo: string, subtitulo: string, msgVazio: string) {
    this.mensagem = '';
    this.modalAcao = acao;
    this.modalTitulo = titulo;
    this.modalSubtitulo = subtitulo;
    this.modalVazioMensagem = msgVazio;
    this.modalFiltro = '';
    this.modalItens = [];
    this.modalSelecionadoId = '';
    this.modalCarregando = true;
    this.modalAberto = true;
  }

  private carregarItensModal() {
    if (!this.modalAcao) {
      return;
    }

    this.modalCarregando = true;
    const filtro = (this.modalFiltro || '').trim();
    const query = filtro ? '?filtro=' + encodeURIComponent(filtro) : '';

    if (this.modalAcao === 'incluirCidade') {
      const url = Helper.baseApiUrl + 'regiao/cidades/' + this.itemCorrente.estadoFk + query;
      this.http.get<Cidade[]>(url).subscribe((res) => {
        this.modalItens = (res || []).map(c => ({
          id: c.cidadeId,
          descricao: c.nome,
          detalhe: ((c.codigoCidade || '') + (c.jaAssociada ? ' • já associada' : '')).trim(),
          bloqueado: !!c.jaAssociada
        }));
        this.modalFiltroAplicado = filtro;
        this.ajustarSelecaoModal();
        this.modalCarregando = false;
      }, () => {
        this.modalCarregando = false;
        this.mensagem = 'Erro ao carregar cidades disponíveis.';
      });
      return;
    }

    const url = Helper.baseApiUrl + 'regiao/cidades/' + this.modalCidadeRegiaoId + '/regioes-destino' + query;
    this.http.get<any[]>(url).subscribe((res) => {
      this.modalItens = (res || []).map(r => ({
        id: r.regiaoId,
        descricao: r.nome,
        detalhe: r.estado
      }));
      this.modalFiltroAplicado = filtro;
      this.ajustarSelecaoModal();
      this.modalCarregando = false;
    }, () => {
      this.modalCarregando = false;
      this.mensagem = 'Erro ao carregar regiões de destino.';
    });
  }

  private ajustarSelecaoModal() {
    if (!this.modalItens || this.modalItens.length === 0) {
      this.modalSelecionadoId = '';
      return;
    }

    const primeiraDisponivel = this.modalItens.find(i => !i.bloqueado);

    if (!primeiraDisponivel) {
      this.modalSelecionadoId = '';
      return;
    }

    const selecionadoExiste = this.modalItens.some(i => i.id === this.modalSelecionadoId && !i.bloqueado);
    if (!selecionadoExiste) {
      this.modalSelecionadoId = primeiraDisponivel.id;
    }
  }

  public estadoDescricao(item: Regiao) {
    if (!item) {
      return '';
    }

    const estado = this.estados.find(e => e.estadoId === item.estadoFk);
    if (estado) {
      return estado.nome + ' (' + estado.codigoEstado + ')';
    }

    return item.estado;
  }
}
